import cx from 'classnames';

import { TEXTAREA_MAX_ROWS } from '../../../../../constants';
import { ITextAreaInputProps } from './types';

export const TextAreaInput = ({ value, onChange, placeholder, className }: ITextAreaInputProps) => (
  <textarea
    value={value}
    onChange={(event) => onChange(event.target.value)}
    placeholder={placeholder ?? undefined}
    rows={TEXTAREA_MAX_ROWS}
    className={cx(className, 'py-4')}
  />
);
